import { createAction, props } from '@ngrx/store';
import { WorkedTimesEntity } from '../../entities/worked-times.entity';
import { QueryWorkedtimesArgs } from '../../graphql-types';

export const WorkedTimesActionTypes = {
    Load: createAction('data/worked-times/get', props<{ Payload?: QueryWorkedtimesArgs }>()),
    UpdateAll: createAction('data/worked-times/updateAll', props<{ Payload: WorkedTimesEntity[], updateLatestUpdatedAt?: boolean }>()),
    UpdateMany: createAction('data/worked-times/updateMany', props<{ Payload: WorkedTimesEntity[], updateLatestUpdatedAt?: boolean }>()),
    RemoveMany: createAction('data/worked-times/removeMany', props<{ Payload: number[] }>()),


    LoadFiltered: createAction(
        'data/worked-times/ensureLoaded',
        props<{ commissionIds: number[]; workDayIds: number[] }>(),
    ),
    LoadByIdsSuccess: createAction(
        'data/worked-times/loadByIdsSuccess',
        props<{
            Payload: WorkedTimesEntity[];
            commissionIds: number[];
            workDayIds: number[];
            serverTimestamp: string;
        }>(),
    ),
    LoadByIdsFailure: createAction(
        'data/worked-times/loadByIdsFailure',
        props<{ commissionIds: number[]; workDayIds: number[]; error: unknown }>(),
    ),

};
